import { SET_CHAT_OPENED_WINDOWS } from '../../constants/ActionTypes';


export default function setChatOpenedWindows(value) {
  return {
    type: SET_CHAT_OPENED_WINDOWS,
    payload: value
  }
}

